import {
	Component, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges, ChangeDetectorRef,
	ChangeDetectionStrategy, ViewRef, OnInit, OnChanges, AfterViewInit, OnDestroy
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { _getOptionScrollPosition, _countGroupLabelsBeforeOption } from '@angular/material/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { SapiService, SapiEntity } from './../../../services/sapi.service';
import { FilterSetService, FilterSet } from './../../../services/filter-set.service';
import { AssetService } from './../../../services/asset.service';
import { PublicationService } from './../../../services/publication.service';
import { LocalStorageService } from 'angular-2-local-storage';

import { QueryParameter } from '../../../interfaces/queryString';
import { PillboxConfiguration, FilterConfigSelect } from '../bb-pillbox/bb-pillbox.component';
import { Publication } from '../../../interfaces/publication';
import { Mediaclip } from '../../../interfaces/mediaclip';

@Component({
	selector: 'bb-select-6',
	templateUrl: './bb-select-6.component.html',
	styleUrls: ['./bb-select-6.component.scss'],
	providers: [FilterSetService, SapiService],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class BbSelect6Component implements OnInit, OnChanges, AfterViewInit, OnDestroy {

	@Input() config: PillboxConfiguration;
	@Input() filterConfig: FilterConfigSelect;
	@Input() id: number;

	@Output() onChangeOption: EventEmitter<any> = new EventEmitter<any>();
	@Output() onDropdownOpen: EventEmitter<boolean> = new EventEmitter<boolean>();

	@ViewChild('inputAutoComplete') private inputRef: ElementRef;
	@ViewChild(MatAutocompleteTrigger) private inputAutoComplete: MatAutocompleteTrigger;
	@ViewChild(MatAutocomplete) private auto: MatAutocomplete;

	selectControl: UntypedFormControl;
	filteredOptions: any[];
	dropdownOpen = false;
	storedFonts: any;
	showMoreClicked = false;
	assetBaseUrl: string;
	baseUrl: string;
	thumbnailSource: string;
	numFound = 0;
	foundOption: any;
	storedIds: string[];
	filterSetQuery: FilterSet;
	selectedApp: any;
	selectedClip: Mediaclip;
	searching = false;
	searched = false;

	webFonts = [
		{ id: '-1', originalfilename: 'Arial', fallback: 'Helvetica, sans-serif' },
		{ id: '-1', originalfilename: 'Arial Black', fallback: 'Gadget, sans-serif' },
		{ id: '-1', originalfilename: 'Bookman Old Style', fallback: 'serif' },
		{ id: '-1', originalfilename: 'Comic Sans MS', fallback: 'cursive, sans-serif' },
		{ id: '-1', originalfilename: 'Courier', fallback: 'monospace' },
		{ id: '-1', originalfilename: 'Courier New', fallback: 'Courier, monospace' },
		{ id: '-1', originalfilename: 'Garamond', fallback: 'serif' },
		{ id: '-1', originalfilename: 'Georgia', fallback: 'serif' },
		{ id: '-1', originalfilename: 'Lucida Console', fallback: 'Monaco, monospace' },
		{ id: '-1', originalfilename: 'Lucida Sans Unicode', fallback: 'Lucida Grande, sans-serif' },
		{ id: '-1', originalfilename: 'MS Sans Serif', fallback: 'Geneva, sans-serif' },
		{ id: '-1', originalfilename: 'MS Serif', fallback: 'New York, sans-serif' },
		{ id: '-1', originalfilename: 'Palatino Linotype', fallback: 'Book Antiqua, Palatino, serif' },
		{ id: '-1', originalfilename: 'Symbol', fallback: 'sans-serif' },
		{ id: '-1', originalfilename: 'Tahoma', fallback: 'Geneva, sans-serif' },
		{ id: '-1', originalfilename: 'Times New Roman', fallback: 'Times, serif' },
		{ id: '-1', originalfilename: 'Trebuchet MS', fallback: 'Helvetica, sans-serif' },
		{ id: '-1', originalfilename: 'Verdana', fallback: 'Geneva, sans-serif' }
	];

	public optionsRetrievedObservable: Subject<any[]>;
	private options: any[];
	private subscriptions = new Subscription();
	private query: string;




	constructor(
		private sapiService: SapiService,
		private filterSetService: FilterSetService,
		private localStorageService: LocalStorageService,
		private assetService: AssetService,
		private publicationService: PublicationService,
		private changeDetector: ChangeDetectorRef) {
		this.options = new Array<any>();
		this.selectControl = new UntypedFormControl();
		this.filteredOptions = new Array<any>();
		this.optionsRetrievedObservable = new Subject<any[]>();
		this.assetBaseUrl = this.assetService.getAssetBaseUrl();
		this.selectedApp = {};
		this.selectedClip = {};
	}

	ngOnInit() {
		this.subscriptions.add(this.publicationService.getData().subscribe((publication: Publication) => {
			if (publication && publication.baseurl) {
				this.baseUrl = publication.baseurl;
			}
		}));

		this.subscriptions.add(this.selectControl.valueChanges.pipe(
			debounceTime(400))
			.subscribe((newValue: string) => {
				this.showMoreClicked = false;

				const indexOfDelim = this.config.value && this.config.value.indexOf(';');
				if ((this.config.value === newValue || this.config.value.substring(indexOfDelim + 1) === newValue ||
					(this.selectedApp && (this.selectedApp.name === newValue || this.selectedApp.id === newValue)) ||
					(this.selectedClip && this.selectedClip.title === newValue || this.selectedClip.originalfilename === newValue)) && !this.query) {
					// initial state, makes sure dropdown doesn't open on init and performs a query with the filename

					newValue = '';
					this.query = '';
					if (this.inputRef) {
						this.inputRef.nativeElement.blur();
					}
				} else if (newValue) {
					// a query is entered by the user, set this.query and do search

					if (this.query !== newValue) {
						this.query = newValue;
						if (this.filterConfig.font) {
							this.filterOptionsForFonts();
						} else {
							this.getOptions();
						}
					}
				} else {
					// the query is removed, so get all options (the initial state)

					newValue = '';
					this.query = '';
					if (this.filterConfig.font) {
						this.filterOptionsForFonts();
					} else {
						this.getOptions();
					}
				}
			})
		);

		this.update();

	}

	update() {
		if (this.config.value && this.config.value !== '__...__') {

			// fetch the entity to get a reference to the name

			if (this.filterConfig.type === 'app') {
				this.sapiService.get('app', this.config.value).subscribe((app: SapiEntity) => {
					if (app) {
						this.selectedApp = app;
						this.selectControl.setValue(this.selectedApp.name);
						if (!(this.changeDetector as ViewRef).destroyed) { // need this when widget changes
							this.changeDetector.detectChanges();
						}
					}
				});
			} else if (this.filterConfig.type === 'image' || this.filterConfig.type === 'media') {
				this.sapiService.get('commonclip', this.config.value).subscribe((clip: Mediaclip) => {
					if (clip) {
						this.selectedClip = clip;
						this.selectControl.setValue(this.config.value);
					}
				});
			} else if (this.filterConfig.font) {
				const indexOfDelim = this.config.value && this.config.value.indexOf(';');
				this.selectControl.setValue(this.config.value.substring(indexOfDelim + 1));
			}
		}

		if (!this.filterConfig.font && this.config.value !== '') {
			this.changeThumbnail(this.config.value);
		} else {
			this.thumbnailSource = null;

			// localstorage, only for fonts
			this.storedFonts = this.localStorageService.get('ovp-lastSelectedFonts');
			if (!this.storedFonts) {
				this.storedFonts = { items: [] };
			}
			if (this.storedFonts && !this.storedFonts.items) {
				this.storedFonts.items = [];
			}
		}

	}

	ngOnChanges(simpleChanges: SimpleChanges) {
		if (simpleChanges.config && !simpleChanges.config.firstChange && simpleChanges.config.currentValue && simpleChanges.config.currentValue) {
			if (simpleChanges.config.currentValue.value !== simpleChanges.config.previousValue.value) {
				this.update();
			}
		}
	}

	ngAfterViewInit() {
		this.setScrollPosition();
	}

	// This is a workaround for hardcoded option height: see https://github.com/angular/material2/issues/3419#issuecomment-416574955
	// The function getOptionScrollPosition can be found here:
	// https://github.com/angular/material2/blob/0f569ff40f4432258ef52f2a6d98fa9d77b0a3b0/src/lib/core/option/option.ts
	setScrollPosition() {
		if (this.inputAutoComplete && this.auto) {
			(this.inputAutoComplete as any)._scrollToOption = () => {
				const optionHeight = 21;
				const panelHeight = 217; // Height of the panel minus the drag&drop div
				const index: number = this.auto._keyManager.activeItemIndex || 0;
				const labelCount = _countGroupLabelsBeforeOption(index, this.auto.options, this.auto.optionGroups);
				const newScrollPosition = _getOptionScrollPosition(index + labelCount,
					optionHeight, this.auto._getScrollTop(), panelHeight);

				this.auto._setScrollTop(newScrollPosition);
			};
		}
	}

	// function for setting separate control and display values
	displayFn(value: any) {
		if (!value) {
			return '';
		} else if (this.filterConfig.font) {
			return value;
		} else if (this.filterConfig.type === 'app') {
			return this.selectedApp.name;
		} else {
			return this.selectedClip.title || this.selectedClip.originalfilename;
		}
	}

	ngOnDestroy() {
		this.changeDetector.detach();
		this.subscriptions.unsubscribe();
	}

	// Frontend filtering - only for fonts
	filterOptionsForFonts() {
		if (this.query) {
			const filterValue = this.query.toLowerCase();
			if (this.filterConfig.font) {
				this.filteredOptions = this.options.filter((option) =>
					option.originalfilename.toLowerCase().includes(filterValue));
			}
		} else {
			this.filteredOptions = this.options;
		}
		if (!(this.changeDetector as ViewRef).destroyed) { // need this when widget changes
			this.changeDetector.detectChanges();
		}
	}

	getOptions() {
		this.searching = true;
		this.options = [];
		this.filteredOptions = [];
		this.numFound = 0;
		const { font, entity, offset, filterSet } = this.filterConfig;
		let mediaType: string;

		if (font) {
			this.storedFonts.items
				.filter((data: any) => data.item.id === '-1')
				.map((data: any) => this.options.push(data.item));

		} else {
			if (filterSet) {
				for (let i = 0; i < filterSet.length; i++) {
					filterSet[i].filters.filter((f) => f.field === 'mediatype')
						.map((f) => {
							if (typeof f.value === 'string') {
								f.value = [f.value];
							}
							f.value.forEach((value) => {
								mediaType = value;
							});
						});
				}
			}
		}

		const queryParameters = this.setQueryParameters(mediaType);

		this.sapiService.query(entity, queryParameters, offset, this.filterConfig.amount, null, null, this.filterSetQuery).subscribe(response => {
			this.searching = false;
			this.searched = true;
			if (font && response && response.items && response.items.length > 0) { // fonts
				for (let i = 0, l = response.items.length; i < l; i++) {
					const customFont = response.items[i] as Mediaclip;
					if (customFont && customFont.originalfilename && customFont.assets) {
						customFont.originalfilename = customFont.originalfilename.slice(0, customFont.originalfilename.lastIndexOf('.'));

						const index = this.storedFonts.items.findIndex((storedFont: any) => storedFont.item.id === customFont.id);
						if (index === -1) {
							this.options.push(customFont);
						} else {
							this.options.splice(index, 0, customFont);
						}
					}
				}
				this.webFonts.map(webFont => {
					if (!this.inStoredFonts(webFont)) {
						this.options.push(webFont);
					}
				});
				this.filterOptionsForFonts();
			} else if (font) {
				this.webFonts.map(webFont => {
					if (!this.inStoredFonts(webFont)) {
						this.options.push(webFont);
					}
				});
				this.filterOptionsForFonts();
			} else if (response && response.items && response.items.length > 0) {
				this.numFound = response.totalAmount;
				this.filteredOptions = [];
				for (let i = 0, l = response.items.length; i < l; i++) {
					if (response.items[i]) {
						this.filteredOptions.push(response.items[i]);
					}
				}
			}

			this.setScrollPosition();
			if (!(this.changeDetector as ViewRef).destroyed) { // need this when widget changes
				this.changeDetector.detectChanges();
			}
		});
	}

	setQueryParameters(mediaType: string) {
		const queryParameters: QueryParameter[] = new Array<QueryParameter>();
		const { font, sortProperty, type } = this.filterConfig;
		let filterSet = this.filterConfig.filterSet;

		if (font) {
			this.filterSetQuery = [];
			queryParameters.push({ name: 'q', values: ['mediatype:' + type] });
			queryParameters.push({ name: 'sort', values: [sortProperty + ' asc'] });
		} else {
			if (this.query) {
				queryParameters.push({ name: 'sort', values: ['score desc,' + sortProperty + ' desc'] });
				if (!this.showMoreClicked) {
					if (!filterSet) {
						filterSet = [];
					}
					this.filterSetQuery = this.filterSetService.addQueryToFilterSet(this.query, filterSet);
				} else {
					this.filterConfig.amount = 20;
				}
			} else {
				queryParameters.push({ name: 'sort', values: [sortProperty + ' desc'] });
				this.filterSetQuery = filterSet;

				if (this.showMoreClicked) {
					this.filterConfig.amount = 20;
				}
			}
		}
		return queryParameters;
	}

	onMatOptionSelected(val: any) {
		// set selectedApp or -clip to selected option
		if (this.filterConfig.type === 'app') {
			this.selectedApp = val;
		} else if (this.filterConfig.type === 'image' || this.filterConfig.type === 'media') {
			this.selectedClip = val;
		}

		// send data to redux: if font as id;name, else id
		if (this.filterConfig.font && val && val.id && val.originalfilename) {

			// localstorage, just for fonts
			const localstorageItem = { id: val.id, originalfilename: val.originalfilename };
			const data = { item: localstorageItem, timestamp: + new Date() };

			// add if the item is not already in the list
			if (!this.inStoredFonts(data.item)) {
				this.storedFonts.items.unshift(data);
				if (this.storedFonts.items.length > 5) {
					// if stored fonts contains 5 items, remove oldest
					this.storedFonts.items.pop();
				}
			}
			this.localStorageService.set('ovp-lastSelectedFonts', this.storedFonts);

			const newVal = `${val.id};${val.originalfilename}`;
			this.onChangeOption.emit(newVal);
		} else {
			this.changeThumbnail(val.id);
			this.onChangeOption.emit(val.id);
			this.filterConfig.amount = 5;
		}

		// reset query and showMoreClicked
		this.query = '';
		this.showMoreClicked = false;
	}

	inStoredFonts(data: any) {
		let check = false;

		// check if the item is in there
		for (let i = 0; i < this.storedFonts.items.length; i++) {
			if (data.id !== '-1' && this.storedFonts.items[i].item.id === data.id) {
				check = true;
			} else if (data.id === '-1' && this.storedFonts.items[i].item.originalfilename === data.originalfilename) {
				check = true;
			}
		}
		return check;
	}

	toggle(bool: boolean) {
		this.dropdownOpen = bool;
		this.onDropdownOpen.emit(this.dropdownOpen); // emit whether the dropdown is open to pillbox < property bar > scrollable pane.
		if (!this.dropdownOpen) {
			// reset search
			if (this.filterConfig.type === 'app') {
				this.selectControl.setValue(this.selectedApp.name);
			} else if (this.filterConfig.type === 'image' || this.filterConfig.type === 'media') {
				this.selectControl.setValue(this.config.value);
			} else if (this.filterConfig.font) {
				const indexOfDelim = this.config.value && this.config.value.indexOf(';');
				this.selectControl.setValue(this.config.value.substring(indexOfDelim + 1));
			}
			this.query = '';
			this.showMoreClicked = false;
		}
	}

	changeThumbnail(id: any) {
		// fonts and apps do not have thumbnails (yet)
		if (!this.filterConfig.font && this.filterConfig.type !== 'app') {
			this.thumbnailSource = `${this.baseUrl}/mediaclip/${id}/spthumbnail/300/200.jpg`;
		}
	}

	onShowMoreClicked() {
		this.showMoreClicked = true;
		this.inputRef.nativeElement.focus();
		this.getOptions();
	}

	openPanel(evt: Event): void {
		evt.stopPropagation();
		this.dropdownOpen = true;
		if (!(this.changeDetector as ViewRef).destroyed) { // need this when widget changes
			this.changeDetector.detectChanges();
		}
		setTimeout(() => {
			this.inputRef.nativeElement.select();
			this.inputRef.nativeElement.focus();
			this.inputAutoComplete.openPanel();
		});
		this.getOptions();
	}

	// function to remove selected images (only for images, because they have hover, active and toggled states)
	onSelectKeydown(value: any, evt: KeyboardEvent) {
		if (!this.filterConfig.font && this.filterConfig.type === 'image' && !value && (evt.key === 'Enter' || evt.key === 'Tab')) {
			this.onChangeOption.emit(value);
			this.thumbnailSource = null;
			this.dropdownOpen = false;
			this.query = '';
		}
	}
}
